class Router {
    getSegments() {
        var segments;

        segments = window.location.search.replace(/^\?/, '').split('&');

        return segments;
    }

    getParam(param) {
        var params = this.getParams();

        return params[param] || null;
    }

    // собираем объект с параметрами
    getParams() {
        var ret = {};
        var seg = this.getSegments();
        var len = seg.length;
        var i = 0;
        var s;

        for (; i < len; i++) {
            if (!seg[i]) {
                continue;
            }
            s = seg[i].split('=');
            ret[s[0]] = decodeURIComponent(s[1]);
        }

        return ret;
    }

    getParamsArray() {
        var ret = [];
        var seg = this.getSegments();
        var len = seg.length;
        var i = 0;
        var s;
        var obj;

        for (; i < len; i++) {
            if (!seg[i]) {
                continue;
            }

            s = seg[i].split('=');
            obj = {
                name: s[0],
                value: s[1],
            };

            ret.push(obj);
        }

        return ret;
    }

    getParamsString() {
        return window.location.search || '';
    }

    paramIsArray(param) {
        return /(.*)\[\]$/.test(param);
    }

    addCountToParam(param, count) {
        return param.replace(/\[\]$/, `[${count}]`);
    }

    /**
     * Добавляет параметры из массива
     * Router.addParamsArray([{name: 't[]', value: 1}, {name: 't[]', value: 4}])
     */
    addParamsArray(params) {
        var p = {};
        var counts = {};
        var name = null;
        var value = null;
        var newName = null;

        if (!params || typeof params !== 'object') {
            return;
        }

        params.forEach((el) => {
            name = el.name || null;
            value = el.value || null;
            if (name && value) {
                if (!counts[name]) {
                    counts[name] = 1;
                } else {
                    counts[name]++;
                }

                if (this.paramIsArray(name)) {
                    newName = this.addCountToParam(name, counts[name]);
                    p[newName] = value;
                } else {
                    p[name] = value;
                }
            }
        });

        this.setLocation(this.get(), p);
    }

    addParam(name, value, push) {
        var p = this.getParams();

        p[name] = value;

        this.setLocation(this.get(), p, push);
    }

    removeParam(name) {
        var p = this.getParams();

        if (p[name]) {
            p[name] = undefined;
        }

        this.setLocation(this.get(), p);
    }

    get() {
        return window.location.pathname || '';
    }

    getHost() {
        return window.location.host || '';
    }

    getPathname() {
        return window.location.pathname || '';
    }

    getHash() {
        return window.location.hash || '';
    }

    getHashName() {
        return this.getHash().replace('#', '');
    }

    getFull() {
        return this.getPathname() + this.getParamsString() + this.getHash();
    }

    getAbsolute(withProtocol) {
        const protocol = withProtocol ? `${this.getProtocol()}//` : '';

        return `${protocol}${this.getHost()}${this.getFull()}`;
    }

    getProtocol() {
        return window.location.protocol || '';
    }

    getHref() {
        return window.location.href || '';
    }

    makeURL(path, params) {
        var s = this.makeStringParams(params);

        return (path && path !== '' ? path : this.getPathname()) + s;
    }

    makeStringParams(p) {
        let s = '';

        if (!p || typeof p !== 'object') {
            return s;
        }

        let seporator = '?';

        Object.keys(p).forEach((key) => {
            const attr = p[key];

            if (attr || attr === 0) {
                s += `${seporator}${key}=${attr}`;
                seporator = '&';
            }
        });

        return s;
    }

    setLocation(location, params, push) {
        var p;
        var s = '';

        if (params !== false) {
            p = params || {};
            s = this.makeStringParams(p);
        } else {
            s = this.getParamsString();
        }

        if (push) {
            history.pushState({}, '', location + s);
        } else {
            history.replaceState({}, '', location + s);
        }

        return false;
    }

    loadLocation(location, params) {
        var p;
        var s = '';

        if (params !== false) {
            p = params || {};
            s = this.makeStringParams(p);
        } else {
            s = this.getParamsString();
        }

        // history.pushState({}, '', location + s);
        window.location = location + s;

        return false;
    }

    reload() {
        window.location.reload();
    }

    moveToLocation(location, params) {
        this.loadLocation(location, params);
    }

    removeHash() {
        this.setLocation(this.getFull().replace(/#.+/g, ''));
    }

    addHash(value) {
        if (!value) {
            return;
        }

        window.location.hash = `#${value}`;
    }

    back() {
        window.history.back();

        return false;
    }
}

export default new Router();
